/* ==========================================================================
   Near-match frames
   --------------------------------------------------------------------------
   Shopify's storefront filtering is all-or-nothing: a product either matches
   every active filter or it is absent. There is no way to rank exact matches
   above partial ones.

   So when a customer picks Language + From + To + Occasion, this runs a second
   query with the occasion dropped, and appends anything new underneath a
   divider. The exact matches stay first, in Shopify's own order; the wider
   set follows as "more frames from Mom to Son".

   The second query goes through the Section Rendering API, so Shopify does the
   filtering — no product data is re-implemented here.
   ========================================================================== */

(function () {
  'use strict';

  var SECTION_ID = 'product-grid';
  var OCCASION = 'filter.p.m.custom.frame_occasions';
  var FROM = 'filter.p.m.custom.frame_from';
  var TO = 'filter.p.m.custom.frame_to';

  function productHref(node) {
    var link = node.querySelector('a[href*="/products/"]');
    return link ? link.getAttribute('href').split('?')[0] : null;
  }

  function run() {
    var params = new URLSearchParams(window.location.search);

    // Only worth doing when an occasion is narrowing a relationship search.
    if (!params.has(OCCASION)) return;
    if (!params.has(FROM) && !params.has(TO)) return;

    var grid = document.getElementById(SECTION_ID);
    if (!grid) return;

    var broader = new URLSearchParams(params);
    broader.delete(OCCASION);
    broader.delete('page');
    broader.set('section_id', SECTION_ID);

    fetch(window.location.pathname + '?' + broader.toString())
      .then(function (response) {
        return response.ok ? response.text() : Promise.reject(response.status);
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var otherGrid = parsed.getElementById(SECTION_ID);
        if (!otherGrid) return;

        var shown = {};
        Array.prototype.forEach.call(grid.children, function (node) {
          var href = productHref(node);
          if (href) shown[href] = true;
        });

        var extras = Array.prototype.filter.call(otherGrid.children, function (node) {
          var href = productHref(node);
          return href && !shown[href];
        });

        if (!extras.length) return;

        var heading = document.createElement('li');
        heading.className = 'gift-related__divider';
        heading.innerHTML =
          '<span class="gift-related__title">' +
          (Object.keys(shown).length
            ? 'Also suitable, for other occasions'
            : 'No exact match — here are other frames for this pair') +
          '</span>';
        grid.appendChild(heading);

        extras.forEach(function (node) {
          node.classList.add('gift-related__item');
          grid.appendChild(node);
        });
      })
      .catch(function () {
        /* A failed second query simply leaves the exact results as they are. */
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
